.left-align {
  background-image: url("../images/text-left.svg");
}

.center-align {
  background-image: url("../images/text-center.svg");
}

.right-align {
  background-image: url("../images/text-right.svg");
}

.justify-align {
  background-image: url("../images/justify.svg");
}

.indent {
  background-image: url("../images/indent.svg");
}

.outdent {
  background-image: url("../images/outdent.svg");
}
